"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const autosave_1 = require("../../../../hooks/autosave");
const validation_1 = require("../../../../hooks/validation");
const constants_1 = require("../../../../entities/contracts/constants");
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const TaskPage_1 = require("../../base/TaskPage");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const ChannelIcon_1 = require("../../../components/icon/ChannelIcon");
const NumericInput_1 = require("../../../components/input/numeric/NumericInput");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const constants_2 = require("../../../../tasks/constants");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Spacer_1 = require("../../../components/spacer/Spacer");
const Heading_1 = require("../../../components/heading/Heading");
const RadioQuestion_1 = require("../../../components/input/radio/RadioQuestion");
const ChannelListStyles = styled_1.default.div `
	.sd-channel {
		padding-top: 10px;
		display: flex;
    	align-items: center;
	}

	.channel-name {
		${theme_1.default.typography.a3}

		padding-left: 10px;
	}
`;
const SecurityDepositChannelList = () => (React.createElement(ChannelListStyles, null,
    React.createElement("div", { className: "sd-channel" },
        React.createElement(ChannelIcon_1.ChannelIcon, { channel: constants_1.Channel.AIRBNB }),
        React.createElement("span", { className: "channel-name" }, "Airbnb")),
    React.createElement("div", { className: "sd-channel" },
        React.createElement(ChannelIcon_1.ChannelIcon, { channel: constants_1.Channel.TRIPADVISOR }),
        React.createElement("span", { className: "channel-name" }, "TripAdvisor"))));
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [hasSecurityDeposit, setHasSecurityDeposit] = React.useState(false);
    const [securityDepositValue, setSecurityDepositValue] = React.useState(100);
    const [valid, errMsg] = (0, validation_1.usePropertyValidation)('security_deposit', property);
    React.useEffect(() => {
        const securityDeposit = property === null || property === void 0 ? void 0 : property.security_deposit;
        if (property && Object.keys(property).includes('security_deposit')) {
            setHasSecurityDeposit(true);
            setSecurityDepositValue(securityDeposit);
        }
    }, [property === null || property === void 0 ? void 0 : property.security_deposit]);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_2.Tasks.SECURITY_DEPOSIT, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Security Deposit"),
                    React.createElement(RadioQuestion_1.YesNoRadioQuestion, { id: "security-deposit-yes-no", question: "Do you charge guests a security deposit?", selected: hasSecurityDeposit, onChange: (_, value) => {
                            setHasSecurityDeposit(value);
                            if (value === true) {
                                update({ security_deposit: securityDepositValue });
                            }
                            else {
                                update({ security_deposit: 0 });
                            }
                        } }),
                    hasSecurityDeposit && (React.createElement(React.Fragment, null,
                        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                        React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "Travelnest only processes security deposits and damage claims on your behalf for the following channels:"),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(SecurityDepositChannelList, null),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" },
                            "For all other channels, ",
                            React.createElement("strong", null, "it is your responsibility"),
                            " to collect security deposits from your guests."),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(NumericInput_1.NumericInput, { label: "How much is your security deposit?", hintText: "If taking a security deposit it must be between \u00A3100 and \u00A31725.", id: "security-deposit-input", value: securityDepositValue, handleChange: (v) => update({ security_deposit: v }), valid: valid, errorMessage: errMsg }))),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.InsightAction, { text: "For extra peace of mind, consider obtaining your own insurance. We recommend Pikl. They provide specialist insurance for vacation rentals.", buttonText: "Visit Pikl", onClick: () => { window.open('https://www.pikl.com/?utm_source=TravelNest&utm_medium=Referral&utm_campaign=TravelNest_ref', '_blank'); } }))))));
};
//# sourceMappingURL=SecurityDepositPage.js.map